import { NavigateFunction } from 'react-router-dom';

import { MButton } from '@Components/Base';
import { ErrorPageTypes } from '@Enum/ErrorPageTypes.enum';
import somethingWentWrongImage from '@Images/errorPages/oops.png';
import notFoundImage from '@Images/errorPages/404.png';
import forbiddenImage from '@Images/errorPages/403.png';
import accessForbiddenImage from '@Images/errorPages/access-forbidden.png';

import styles from './error-page.module.css';

type PageData = {
  image: JSX.Element;
  title: JSX.Element | null;
  description: JSX.Element | null;
  button: JSX.Element;
};

export const getPageSpecificData = (
  type: ErrorPageTypes,
  navigate: NavigateFunction,
  logout: () => void
): PageData => {
  const navigateToHome = (): void => {
    navigate('/');
  };

  const navigateFromForbiddenPage = (): void => {
    logout();
  };

  if (type === ErrorPageTypes.NOT_FOUND) {
    const output = {
      image: <img className={styles.img} src={notFoundImage} alt="404" />,
      title: <div className={styles.title}>Page Not Found</div>,
      description: (
        <div className={styles.description}>
          The page you are looking for is currently unavailable.
          <br />
          Please visit our other sections or return to dashboard.
        </div>
      ),
      button: (
        <MButton type="primary" onClick={navigateToHome}>
          Go to Dashboard
        </MButton>
      ),
    };
    return output;
  }

  if (type === ErrorPageTypes.ACCESS_FORBIDDEN) {
    const output = {
      image: <img className={styles.img} src={accessForbiddenImage} alt="X" />,
      title: <div className={styles.title}>Access Forbidden</div>,
      description: (
        <div className={styles.description}>
          Oops! It seems you do not have permission to view this page.
          <br />
          Request access below, and our team will assist you shortly.
        </div>
      ),
      button: (
        <MButton
          type="primary"
          onClick={() => {
            // mock, to be implemented in future
          }}
        >
          Request Access
        </MButton>
      ),
    };
    return output;
  }

  if (type === ErrorPageTypes.FORBIDDEN) {
    const output = {
      image: <img className={styles.img} src={forbiddenImage} alt="403" />,
      title: <div className={styles.title}>Access Forbidden</div>,
      description: (
        <div className={styles.description}>
          Oops! It seems you do not have permission to view this page.
          <br />
          Request access below, and our team will assist you shortly.
        </div>
      ),
      button: (
        <MButton type="primary" onClick={navigateFromForbiddenPage}>
          Back To homepage
        </MButton>
      ),
    };
    return output;
  }

  const somethingWentWrong = {
    image: (
      <img className={styles.img} src={somethingWentWrongImage} alt="OOPS" />
    ),
    title: <div className={styles.title}>Something Went Wrong</div>,
    description: (
      <div className={styles.description}>
        It seems like we are having some problems loading this section
      </div>
    ),
    button: (
      <MButton
        type="primary"
        onClick={() => {
          window.history.back();
        }}
      >
        Refresh
      </MButton>
    ),
  };
  return somethingWentWrong;
};
